<template>
  <transition name="fade">
    <div class="loginModal" v-if="show">
      <div class="overlay" v-on:click="show = false"></div>
      <div class="modalContent">
        <div class="close" v-on:click="show = false"></div>
        <h4 class="title">{{detail.group.name}}</h4>
        <label>Kreator dari</label>
        <div class="contentItem">
          <div class="contentImg" :style="{backgroundImage: `url(${detail.thumb})`}"
            v-if="detail.thumb"></div>
          <div class="contentImg noImg" v-else></div>
          <h4>{{detail.title.substr(0, 65)}}<span v-if="detail.title.length > 65"
            >...</span></h4>
        </div>
        <label>Anggota</label>
        <div class="memberCnt">
          <div class="member" v-for="(item, i) in detail.group.members" :key="i">
            {{i + 1}}. {{item.model}}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      loading: false,
      next: null,
      detail: null,
    };
  },
  methods: {
    close(ok) {
      this.show = false;
      document.querySelector('body').classList.remove('ofw-hdn');
      if (this.next) this.next(ok);
    },
    open(d, next) {
      this.detail = d;
      this.next = next;
      this.show = true;
      document.querySelector('body').classList.add('ofw-hdn');
    },
  },
};
</script>

<style scoped lang="scss">
.loginModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 1;
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    padding: 40px 60px 30px;
    width: 460px;
    background-size: auto 300px;
    background-position: 87% center;
    background-repeat: no-repeat;
    .close{
      position: absolute;
      right: 10px; top: 10px;
      width: 40px; height: 40px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .4;
      cursor: pointer;
      transition: all .2s ease;
      &:hover{
        background-color: #e9e9e9;
        opacity: .8;
      }
    }
    h4.title{
      font-size: 26px;
      margin: 0 0 10px;
    }
    label{
      font-size: 15px;
      color: #767676;
      display: block;
    }
    .contentItem{
      position: relative;
      min-height: 60px;
      border-radius: 5px;
      padding: 10px 16px;
      padding-left: 64px;
      border: #eee 1px solid;
      box-sizing: border-box;
      margin-bottom: 16px;
      .contentImg{
        width: 40px; height: 40px;
        position: absolute;
        left: 10px; top: 10px;
        background-color: #eee;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        &.noImg{
          background-size: 20px auto;
          background-image: url(../assets/image-black.png);
          background-color: #ccc;
          opacity: .3;
        }
      }
      h4{
        margin: 0;
        font-weight: normal;
        line-height: 1.2;
      }
    }
    .memberCnt{
      .member{
        padding: 4px 0;
      }
    }
    @media (max-width: 680px){
      position: absolute;
      top: 50%; left: 10px; right: 10px;
      width: auto;
      transform: translateY(-50%);
      font-size: 15px;
      padding: 50px 30px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
